export default __webpack_public_path__ + "static/media/carousel3.2e374005.png";